import { useState, useContext, useEffect } from "react";
import { Stack, StackItem } from "@fluentui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { Text, Body1, Popover, PopoverTrigger, Button, PopoverSurface, Divider, Avatar, Card, Body1Strong, Image, Tooltip, FluentProvider, Textarea, Caption1, Link, Caption1Strong, Badge, webDarkTheme, } from "@fluentui/react-components";
import { Alert20Regular, Settings20Regular, ChevronDown20Regular, SignOut20Regular, ChatBubblesQuestion20Regular, PersonFeedback20Regular, EmojiSmileSlight24Filled, EmojiSmileSlight24Regular, EmojiSad24Filled, EmojiSad24Regular } from "@fluentui/react-icons";
import { CheckBox } from "../checkbox/checkbox_component";
import OverLay from "../side_menu/overlay_side_menu.component";
import NotificationCard from "../card/notification.card.component";
import ManageView from "../manage_view/manageView.component";
import apiCall from "../../utility/api";
import ProfileDrawerHeader from "../profile/profileDrawerHeader";
import { GlobalContext } from "../../hooks/globalContext";
import { dashboardTheme, deleteIcon, newBackground, primaryIcon, textHover } from "../../styles/customStyles";
import { Feedback_Func } from "../../api/feedback/feedback_func";
import { ChangePasswordForm } from "../../pages/signin/changepasswordform";
import { usePermissionStore } from "../../Store/permissionStore";
import { ProfileDrawer } from "../profile/profileDrawer";

interface iUsers {
  firstName?: string;
  lastName?: string;
  timezone?: string;
  formData?: any;
  firstNameError?: string,
  lastNameError?: string,
  timezoneError?: string,
};

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const contextValue = useContext(GlobalContext);
  console.log('Context: ', contextValue);

  var utcZone = contextValue.userSessionDetails?.otherDetails?.TimeZone;
  var userDetailsFromLocalStorage: any = localStorage.getItem('userDetails');
  userDetailsFromLocalStorage = JSON.parse(userDetailsFromLocalStorage);

  // utcZone = contextValue?.userSessionDetails?.rawData?.timezone;
  // if(userDetailsFromLocalStorage == null || userDetailsFromLocalStorage === undefined){
  //   localStorage.setItem('userDetails',JSON.stringify(contextValue.userSessionDetails.rawData));
  // }

  const initialUserData: iUsers = {
    firstName: contextValue.userSessionDetails?.otherDetails?.firstName,
    lastName: contextValue.userSessionDetails?.otherDetails?.lastName,
    timezone: utcZone,
    formData: contextValue.userSessionDetails?.otherDetails,
    firstNameError: '',
    lastNameError: '',
    timezoneError: '',
  };

  if (!utcZone && userDetailsFromLocalStorage) { utcZone = userDetailsFromLocalStorage?.timezone };
  if (!userDetailsFromLocalStorage) { localStorage.setItem('userDetails', sessionStorage.getItem('userDetails')) };
  // const timezones = ` UTC${(new Date().getTimezoneOffset() > 0 ? "-" : "+")}${Math.abs(new Date().getTimezoneOffset() / 60).toString().padStart(2, '0')}:00`;

  const timeZone = utcZone ? utcZone : Intl.DateTimeFormat().resolvedOptions().timeZone;
  const forms = { Experience: '', Expression: '', ContactMe: 'No', Email: '' };

  const [formData, setFormData]: any = useState(forms);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [isChecked, setIsChecked]: any = useState(false);
  const [formSubmit, setFormSubmit]: any = useState(false);
  const [feedbackUnsatisfied, setFeedbackUnsatisfied]: any = useState(true);
  const [feedbackSatisfied, setFeedbackSatisfied]: any = useState(true);
  const [errorMessage, setErrorMessage]: any = useState('');
  const [overlayName, setOverlayName] = useState('');
  const [selectedTimezone, setSelectedTimezone]: any = useState([timeZone]);
  const [userData, setUserData]: any = useState<iUsers>(initialUserData)
  const [query, setQuery] = useState<string>(timeZone);
  const [lastLogin, setLastLogin] = useState<Date | null>(null);

  const { permissions } = usePermissionStore();

  const fetchLastLogin = () => { setTimeout(() => { setLastLogin(new Date()) }, 1000) };

  useEffect(() => {
    setSelectedTimezone(utcZone);
  }, [utcZone]);

  useEffect(() => {
    if (!overlayOpen) {
      setFeedbackUnsatisfied(true);
      setFeedbackSatisfied(true);
      setFormData({ ...formData, Experience: "", })
      setIsChecked(false)
    };
  }, [overlayOpen]);

  useEffect(() => {
    fetchLastLogin();
  }, []);

  const getUserProfileDetails = async (user_email: string) => {
    try {
      const { data } = await apiCall('/users/getUsersDetails', { user_email }); // response
      console.log("API data: ", data);
      if (data?.length > 0) {
        const { firstName: FN, lastName: LN, timezone: TZ, formData: FD } = data[0];
        setUserData({ ...userData, firstName: FN || '', lastName: LN || '', timezone: TZ || '', formData: FD || {} });
        console.log('User details: ', data[0]);
      } else {
        console.log('No user details found...');
        // setUserData({ ...userData, firstName: '', lastName: '', timezone: '' }); // Handle the case where no user details were found (optional)
      }
    } catch (error) {
      console.error('Error fetching user details: ', error);
      // Optionally set an error state or message for the user
      // setUserData({ ...userData, firstName: '', lastName: '', timezone: '' });
      // alert('Failed to fetch user details. Please try again later.'); // You can also display user feedback (if using a notification system)
    }
  };

  useEffect(() => {
    if (pro && overlayOpen) { getUserProfileDetails(contextValue?.userSessionDetails?.userEmail) }
  }, [overlayOpen, overlayName, contextValue?.userSessionDetails?.userEmail]);

  const userLastLogin = (lastLogin: Date | null): string => {
    const twos = '2-digit';
    return (
      !lastLogin ? 'Loading...' : lastLogin.toLocaleString('en-US', {
        year: 'numeric', month: 'short', day: twos, hour: twos, minute: twos, second: twos, timeZoneName: 'short'
      })
    )
  };

  formData.Email = sessionStorage.getItem('userEmail');

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevData: any) => (name === 'experience' ? { ...prevData, Experience: value } : prevData));
    console.log("Checking: ", value);
  };

  console.log("Form Data: ", formData);

  useEffect(() => {
    formData.Expression = feedbackUnsatisfied ? "Satisfied" : feedbackSatisfied ? "Unsatisfied" : null;
  }, [feedbackUnsatisfied, feedbackSatisfied]);

  function caps(string: any) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  function pics(string: any) {
    return string.charAt(0).toUpperCase();
  };

  const usernameContent = contextValue?.userSessionDetails?.userName;
  const firstName = contextValue.userSessionDetails?.otherDetails?.firstName;
  const lastName = contextValue.userSessionDetails?.otherDetails?.lastName;
  const userName = `${usernameContent?.toLowerCase() === "admin" ? "Admin" : `${caps(usernameContent)} ${caps(contextValue.userSessionDetails.userLName)}`}`;
  const userEmail = contextValue.userSessionDetails.userEmail;
  const userAvatar = `${usernameContent?.toLowerCase() === 'admin' ? pics('Admin') : `${pics(usernameContent)} ${pics(contextValue.userSessionDetails.userLName)}`}`;

  var userRole = contextValue.isRole ? contextValue?.isRole : contextValue?.userSessionDetails?.otherDetails?.role;

  console.log('Checking userRole: ', userRole);

  if (userRole === '' || typeof userRole === 'undefined') {
    userRole = userDetailsFromLocalStorage?.role_assigned;
    console.log('Checking userRole: ', userRole)
  };

  const notify = overlayName === 'notification';
  const pro = overlayName === 'profile';
  const pass = overlayName === 'changePassword';
  const view = overlayName === 'manageview';
  const feedback = overlayName === 'Share your feedback with Nanoheal';

  const handleHome = () => { navigate("/home") };
  const handleSignOut = async () => { // revokeUserSession
    const { status, data } = await apiCall('/users/revokeUserSession', {});
    localStorage.clear();
    sessionStorage.clear();
    contextValue?.setLogedInFrom({});
    navigate("/");
  };
  const ChangeBtn = () => { navigate("/auth/change-password") };
  const ViewBtn = () => { setOverlayOpen(true); setOverlayName('manageview'); };
  const NotificationBtn = () => { setOverlayOpen(true); setOverlayName('notification'); };
  const AdminBtn = () => { navigate("/manage/administration/role") };
  const feedbackBtn = () => { setOverlayOpen(true); setOverlayName('Share your feedback with Nanoheal') };
  const supportBtn = () => { window.open("https://www.nanoheal.com/", "_blank") };
  const handleViewAccount = () => { setOverlayOpen(true); setOverlayName('profile') };
  const handleChangePassword = () => { setOverlayOpen(true); setOverlayName('changePassword') };
  const handleSatisfied = () => { setFeedbackSatisfied(!feedbackSatisfied); setFeedbackUnsatisfied(true) };
  const handleUnsatisfied = () => { setFeedbackUnsatisfied(!feedbackUnsatisfied); setFeedbackSatisfied(true) };
  const handleText = (e: any) => { handleChange(e) };
  const handleViewSave = () => {
    const { module: pdModule, page: pdPage } = contextValue.manageViewPageDetails; // pageDetails
    let newData = contextValue.manageViewDropDownData.map(({ selected, addItem, deleteItem, ...val }) => ({
      ...val,
      ...(addItem && { display: { table: "Yes", filter: "Yes" } }),
      ...(deleteItem && { display: { table: "No", filter: "No" } }),
    }));
    newData = newData.map((val: { priority: any; }, i: string | number) => {
      val.priority = newData.map((val: { priority: any }) => val.priority).sort()[i];
      return val;
    });
    contextValue?.setTableColumnsData({ ...contextValue?.tableColumnsData, [pdModule]: { ...contextValue?.tableColumnsData[pdModule], [pdPage]: newData } });
    localStorage.setItem("tableColumnsData", JSON.stringify({ ...contextValue?.tableColumnsData, [pdModule]: { ...contextValue?.tableColumnsData[pdModule], [pdPage]: newData } }));
    setOverlayOpen(false);
  };

  const handleManageViewSaveBtn = () => {
		const pageDetails = contextValue.manageViewPageDetails;

		let newData = contextValue.manageViewDropDownData.map((val:any) => {
			delete val.selected;
		
			if(val.addItem===true){
				val.display={"table":"Yes","filter":"Yes"}
				delete val.addItem;
			}
			if(val.deleteItem===true){
				val.display={"table":"No","filter":"No"}
				delete val.deleteItem;
			}
			return val;
		});

		const priorityArr = newData.map((val) => val.priority);
		const sortedPriorityArr = priorityArr.sort();

		newData = newData.map((val, i) => {
			val.priority = sortedPriorityArr[i];
			return val;
		});

		contextValue?.setTableColumnsData({...contextValue?.tableColumnsData, [`${pageDetails.module}`] : {...contextValue?.tableColumnsData[`${pageDetails.module}`], [`${pageDetails.page}`] : newData}});

		localStorage.setItem("tableColumnsData", JSON.stringify({...contextValue?.tableColumnsData, [`${pageDetails.module}`] : {...contextValue?.tableColumnsData[`${pageDetails.module}`], [`${pageDetails.page}`] : newData}}));
		
		setOverlayOpen(false);
	}
  const handleViewCancel = () => { setOverlayOpen(false); setIsChecked(false); };
  const handleFeedbackSubmit = () => {
    setOverlayOpen(false); setFormSubmit(true); setIsChecked(false); setFeedbackUnsatisfied(true); setFeedbackSatisfied(true);
  };
  const handleFeedbackCancel = () => {
    setOverlayOpen(false); setIsChecked(false); setFeedbackSatisfied(true); setFeedbackUnsatisfied(true);
    setFormData({ ...formData, Experience: "" })
  };
  const handleWebCheckbox = (e: any) => {
    const checked = e.target.checked;
    setIsChecked(checked);
    setFormData((prevData: any) => ({ ...prevData, ContactMe: checked ? 'Yes' : 'No' }));
  };

  const avatarName = () => <Avatar name={userAvatar} size={72} active="active" color="colorful" activeAppearance="ring-shadow" badge={{ status: "available" }} />;

  const appTitle = () => (
    <StackItem align="center">
      <Stack tokens={{ childrenGap: 20 }} horizontal verticalAlign="center">
        <StackItem>
          <Button shape="circular" id="buttontransparent" size="small" appearance="subtle" onClick={handleHome}>
            <Stack horizontal tokens={{ childrenGap: 10 }} verticalAlign="center">
              <Image src="/Dashboard/image/Nanoheal_logo.svg" height={20} />
              <Body1> Nanoheal Management Portal </Body1>
            </Stack>
          </Button>
        </StackItem>
        <StackItem> <Divider vertical /> </StackItem>
      </Stack>
    </StackItem>
  );

  const signOutButton = () => (
    <StackItem>
      <Stack grow horizontalAlign="end">
        <Button shape="circular" size="small" appearance="transparent" icon={<SignOut20Regular />} iconPosition="after" onClick={handleSignOut}>
          <Caption1Strong> Sign out </Caption1Strong>
        </Button>
      </Stack>
    </StackItem>
  );

  const headerButton = () => {
    const headerPermit = permissions.includes("all") || permissions.includes("administration_Read") || permissions.includes("administration_ReadandExport") || permissions.includes("administration_Fullaccess");

    const badges = (icon: any) => <Badge shape="square" appearance="filled" color="important" size="extra-large"> {icon} </Badge>;

    const headerButtons = [
      // { icon: <LockClosedKey20Regular />, tooltipContent: "Change password", openIcon: ChangeBtn },
      { icon: null, tooltipContent: "Click here to Manage view", openIcon: ViewBtn, display: "none", id: "manageView" },
      {
        icon: overlayOpen && notify ? badges(<Alert20Regular />) : <Alert20Regular />,
        tooltipContent: "Notifications", openIcon: NotificationBtn, display: null, id: null
      },
      {
        icon: <Settings20Regular />, tooltipContent: headerPermit ? "Administration" : "You do not have access",
        ...(headerPermit && { openIcon: AdminBtn }), display: null, id: null
      },
      {
        icon: overlayOpen && feedback ? badges(<PersonFeedback20Regular />) : <PersonFeedback20Regular />,
        tooltipContent: "Feedback", openIcon: feedbackBtn, display: null, id: null
      },
      { icon: <ChatBubblesQuestion20Regular />, tooltipContent: "Contact Support", openIcon: supportBtn, display: null, id: null },
    ];

    return (
      <StackItem>
        <Stack tokens={{ childrenGap: 10, padding: 4 }} enableScopedSelectors horizontal horizontalAlign="space-between">
          {headerButtons.map(({ tooltipContent, icon, openIcon, display, id }, index) => (
            <StackItem key={index} style={{ display: display }}>
              <Tooltip withArrow content={tooltipContent} relationship="label">
                <Button shape="circular" id={id} className="buttontransparentHeader" appearance="transparent" icon={icon} onClick={openIcon} /*id="buttontransparent"*/ />
              </Tooltip>
            </StackItem>
          ))}
        </Stack>
      </StackItem>
    )
  };

  // console.log("Username: ", userName);
  const userNameData = () => (
    <PopoverTrigger disableButtonEnhancement>
      <Button shape="circular" id="buttontransparent" appearance="transparent">
        <Stack horizontal tokens={{ childrenGap: 10 }} verticalAlign="center">
          <StackItem> <Body1> Welcome, {userName} </Body1> </StackItem>
          <StackItem> <ChevronDown20Regular /> </StackItem>
        </Stack>
      </Button>
    </PopoverTrigger>
  );

  const usernameDetails = () => (
    <StackItem>
      <Stack tokens={{ childrenGap: 30, padding: 10 }} horizontal>
        {avatarName()}
        <Stack tokens={{ childrenGap: 5 }}>
          <Body1Strong> {userName} </Body1Strong>
          <Body1 style={{ color: 'grey' }}> {userEmail} </Body1>
          <Stack tokens={{ childrenGap: 5 }} verticalAlign="center">
            <Caption1Strong> Time Zone: <Caption1> {selectedTimezone} </Caption1> </Caption1Strong>
            <Stack horizontalAlign="end" horizontal tokens={{ childrenGap: 10 }}>
              <StackItem>
                <Link onClick={handleViewAccount} style={textHover}> <Caption1Strong> View Account </Caption1Strong> </Link>
              </StackItem>
              <StackItem>
                <Link onClick={handleChangePassword} style={textHover}> <Caption1Strong> Change Password </Caption1Strong> </Link>
              </StackItem>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </StackItem>
  );

  const overLayData = () => {
    const iconSatisfied = feedbackSatisfied ? <EmojiSmileSlight24Regular {...primaryIcon} /> : <EmojiSmileSlight24Filled {...primaryIcon} />;
    const iconUnsatisfied = feedbackUnsatisfied ? <EmojiSad24Regular {...deleteIcon} /> : <EmojiSad24Filled {...deleteIcon} />;
    const disableFeedback = feedbackSatisfied && feedbackUnsatisfied || (formData.Experience === '' && formData.Expression === '');

    const feedbackDrawerBody = () => (
      <form>
        <Stack tokens={{ childrenGap: 10 }}>
          <Body1> Thank you for taking the time to give us feedback. </Body1>
          <Divider />
          <Body1> Are you satisfied with your experience? <Image src="/Dashboard/image/required.svg" /> </Body1>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            <Tooltip withArrow appearance="inverted" positioning="below" relationship="label" content={feedbackSatisfied ? "Satisfied" : "Satisfied"}>
              <Button shape="circular" appearance="transparent" icon={iconSatisfied} onClick={handleSatisfied} />
            </Tooltip>
            <Tooltip withArrow appearance="inverted" positioning="below" relationship="label" content={feedbackUnsatisfied ? "Not Satisfied" : "Not Satisfied"}>
              <Button shape="circular" appearance="transparent" icon={iconUnsatisfied} onClick={handleUnsatisfied} />
            </Tooltip>
          </Stack>
          <Textarea name="experience" size="small" placeholder="Tell us about your experience..." rows={10} onChange={handleText} value={formData.Experience} />
        </Stack>
      </form>
    );

    const manageViewFooter = () => (
      <Stack tokens={{ childrenGap: 10 }}>
        <Stack tokens={{ childrenGap: 10 }} horizontal>
          <Button shape="circular" appearance="primary" onClick={handleManageViewSaveBtn} type="submit"> Save </Button>
          <Button shape="circular" appearance="secondary" onClick={handleViewCancel}> Cancel </Button>
        </Stack>
      </Stack>
    );

    const feedbackFooter = () => (
      <Stack tokens={{ childrenGap: 10 }}>
        <CheckBox size="large" type="checkbox" label="It's OK to contact me about my feedback." checked={isChecked} onChange={handleWebCheckbox} style={{ marginLeft: '-8px' }} />
        <Body1> By pressing submit, you agree that your feedback will be used by us to improve our services and products. </Body1>
        <Stack tokens={{ childrenGap: 10 }} horizontal>
          <Button shape="circular" appearance="primary" type="submit" onClick={handleFeedbackSubmit} disabled={disableFeedback}>
            Submit
          </Button>
          <Button shape="circular" appearance="secondary" onClick={handleFeedbackCancel}> Cancel </Button>
        </Stack>
      </Stack>
    );

    const overlayheader = (
      notify
        ? "Notifications"
        : pro
          ? <ProfileDrawerHeader userData={userDetailsFromLocalStorage} setOverlayOpen={setOverlayOpen} usernameAvatar={avatarName} />
          : pass
            ? "Change Password"
            : view
              ? "Edit columns"
              : "Share your feedback with Nanoheal"
    );

    const overlaybody = (
      notify
        ? <NotificationCard userRole={userRole} overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} />
        : pro
          ? <ProfileDrawer userData={userData} userRole={userRole} userEmail={userEmail} errorMessage={errorMessage} setQuery={setQuery} utcZone={utcZone} firstName={firstName} lastName={lastName} setUserData={setUserData} userDetailsFromLocalStorage={userDetailsFromLocalStorage} setErrorMessage={setErrorMessage} setOverlayOpen={setOverlayOpen} />
          : view
            ? <ManageView overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} />
            : pass
              ? <ChangePasswordForm overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} />
              : feedbackDrawerBody()
    );

    const overlayfooter = (
      view
        ? manageViewFooter()
        : (pro || notify || pass)
          ? null
          : feedbackFooter()
    );

    const overLayContent = {
      isTabs: false, size: "medium", headerTitle: overlayheader, bodyData: overlaybody, footerData: overlayfooter
    };

    return <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData={overLayContent} />;
  };

  const visibleHeader = !(["/", "/signin", "/auth/reset-password", "/signup", "/generatepassword", "/auth/change-password", "/verifyotp", "/unauthorised", "/restricted", "/Dashboard"].includes(location.pathname));
  const store = localStorage.getItem("LogedInFrom");
  const services = ((store !== null && store !== undefined && JSON.parse(store)?.platform === "ServiceNow") || contextValue?.logedInFrom?.platform === "ServiceNow");

  return visibleHeader ? (
    <FluentProvider theme={webDarkTheme}>
      <Stack verticalAlign="center" tokens={{ childrenGap: 2 }}>
        <Stack horizontal horizontalAlign="space-between" enableScopedSelectors>
          {appTitle()}
          {services ? signOutButton() :
            <StackItem>
              <Stack horizontal tokens={{ childrenGap: 2 }}>
                {headerButton()}
                <Stack tokens={{ childrenGap: 2 }}>
                  <Text align="center">
                    <Popover>
                      {userNameData()}
                      {!overlayOpen &&
                        <FluentProvider theme={dashboardTheme}>
                          <PopoverSurface tabIndex={-1}>
                            <Card size="small" appearance="filled-alternative">
                              {signOutButton()}
                              {usernameDetails()}
                            </Card>
                          </PopoverSurface>
                        </FluentProvider>}
                    </Popover>
                  </Text>
                </Stack>
              </Stack>
            </StackItem>}
        </Stack>
        <Feedback_Func formData={formData} setFormData={setFormData} setFormSubmit={setFormSubmit} formSubmit={formSubmit} />
        {overLayData()}
      </Stack>
    </FluentProvider>) : <Card appearance="subtle" style={{ ...newBackground, width: '60%', height: 40 }} />
};

export default Header;
